module.exports = __webpack_public_path__ + "9f2db6c540701515590bdfefd742ab21.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-21.png
// module id = 2101
// module chunks = 0